/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ZipInputs */

const de__field_zip = /** @type {(inputs: _Field_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ`)
};

/**

* @param {_Field_ZipInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_zip = /** @type {((inputs?: _Field_ZipInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ZipInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zip(inputs)
});